import { useEffect, useState } from "react";

export const useSidebarState = () => {
    const [menuState, setMenuState] = useState<"collapsed" | "overlay" | "fixed">("fixed");

    useEffect(() => {
        const handleResize = () => {
            setMenuState(window.innerWidth <= 1024 ? "collapsed" : "fixed");
        };

        // Set initial state
        handleResize();

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleCollapsed = () => {
        setMenuState(menuState !== "fixed" ? "fixed" : "collapsed");
    };

    const handleMouseEnter = () => {
        if (menuState === "collapsed") {
            setMenuState("overlay");
        }
    };

    const handleMouseLeave = () => {
        if (menuState === "overlay") {
            setMenuState("collapsed");
        }
    };

    const isCollapsed = menuState === "collapsed";

    return { menuState, isCollapsed, toggleCollapsed, handleMouseEnter, handleMouseLeave };
};
